module.exports = __webpack_public_path__ + "static/img/morning_show_logo.6cbbdb7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/common/recruit_2021/program_logo/morning_show_logo.png
// module id = i+BY
// module chunks = 0